import { ConfigProvider, theme } from 'antd';

export const comicTheme =
{

    algorithm: theme.defaultAlgorithm,
    token: {
        colorPrimary: '#ff8800',
        colorSuccess: '#facc15',
        colorWarning: '#ef4444',
        colorError: '#dc2626',
        colorInfo: '#0ea5e9',
        colorTextBase: '#4b2e00',
        colorBgBase: '#fff7ed',
        colorPrimaryBg: '#fff7e6',
        colorPrimaryBgHover: '#ffe7b8',
        colorPrimaryBorder: '#ffcc80',
        colorPrimaryBorderHover: '#ffad42',
        colorPrimaryHover: '#ffa726',
        colorPrimaryActive: '#e65100',
        colorPrimaryText: '#ff8800',
        colorPrimaryTextHover: '#ffa726',
        colorPrimaryTextActive: '#e65100',
        colorSuccessBg: '#fffbe6',
        colorSuccessBgHover: '#fff9c2',
        colorSuccessBorder: '#f5e682',
        colorSuccessBorderHover: '#f0d840',
        colorSuccessHover: '#facc15',
        colorSuccessActive: '#ca8a04',
        colorSuccessText: '#ca8a04',
        colorSuccessTextHover: '#facc15',
        colorSuccessTextActive: '#a16207',
        colorWarningBg: '#fef2f2',
        colorWarningBgHover: '#fee2e2',
        colorWarningBorder: '#fecaca',
        colorWarningBorderHover: '#fca5a5',
        colorWarningHover: '#ef4444',
        colorWarningActive: '#b91c1c',
        colorWarningText: '#ef4444',
        colorWarningTextHover: '#f87171',
        colorWarningTextActive: '#b91c1c',
        colorErrorBg: '#fef2f2',
        colorErrorBgHover: '#fee2e2',
        colorErrorBorder: '#fecaca',
        colorErrorBorderHover: '#fca5a5',
        colorErrorHover: '#ef4444',
        colorErrorActive: '#b91c1c',
        colorErrorText: '#dc2626',
        colorErrorTextHover: '#ef4444',
        colorErrorTextActive: '#991b1b',
        colorInfoBg: '#f0f9ff',
        colorInfoBgHover: '#e0f2fe',
        colorInfoBorder: '#bae6fd',
        colorInfoBorderHover: '#7dd3fc',
        colorInfoHover: '#38bdf8',
        colorInfoActive: '#0284c7',
        colorInfoText: '#0ea5e9',
        colorInfoTextHover: '#38bdf8',
        colorInfoTextActive: '#0369a1',
        colorText: 'rgba(75, 46, 0, 0.85)',
        colorTextSecondary: 'rgba(75, 46, 0, 0.65)',
        colorTextTertiary: 'rgba(75, 46, 0, 0.45)',
        colorTextQuaternary: 'rgba(75, 46, 0, 0.25)',
        colorTextDisabled: 'rgba(75, 46, 0, 0.25)',
        colorBgContainer: '#ffffff',
        colorBgElevated: '#ffffff',
        colorBgLayout: '#fff7ed',
        colorBgSpotlight: 'rgba(75, 46, 0, 0.85)',
        colorBgMask: 'rgba(75, 46, 0, 0.45)',
        colorBorder: '#eab308',
        colorBorderSecondary: '#fde68a',
        borderRadius: 12,
        borderRadiusXS: 4,
        borderRadiusSM: 8,
        borderRadiusLG: 16,
        padding: 16,
        paddingSM: 12,
        paddingLG: 24,
        margin: 16,
        marginSM: 12,
        marginLG: 24,
        boxShadow: '0 4px 16px 0 rgba(255, 136, 0, 0.15)',
        boxShadowSecondary: '0 6px 24px 0 rgba(255, 136, 0, 0.2)',
    }
};
